import {
  // eslint-disable-next-line import/named
  downloadBlob,
  // eslint-disable-next-line import/named
  exportDataToCsv,
  exportImage,
} from "../../../../../../../../common/utils";
import GraphAnalysis from "../../../../../../../../common/utils/snaAnalysis/snaAnalysis";

const exportImageHandler = (element, options = {}) => {
  const resolution = options.resolution || 1;

  return new Promise((resolve, reject) => {
    exportImage(element, {
      fileName: `hsna-societyNetwork-${new Date().getTime()}.${
        options.extension || "png"
      }`,
      resolution,
      mineType: options.mineType,
    })
      .then((res) => {
        if (res.finish) {
          resolve("下載檔案完成");
        } else {
          throw new Error("下載檔案失敗");
        }
      })
      .catch((err) => {
        reject(new Error("下載檔案失敗"));
      });
  });
};

const handleExportMeetCount = (groupNetwork, alertFunc, onSuccess, onError) => {
  // check data
  if (groupNetwork && Object.keys(groupNetwork.nodes).length === 0) {
    if (alertFunc) alertFunc("目前沒有任何資料！");
    return;
  }
  // define data and fields
  const data = groupNetwork.nodes;
  const fields = ["id", "count"];
  // export data and download automatically
  exportDataToCsv(data, { fields, onSuccess, onError });
};

// relation-matrix-export click handler
const relationMatrixExport = (groupNetwork, alertFunc, onSuccess, onError) => {
  try {
    // check data
    if (groupNetwork && Object.keys(groupNetwork.nodes).length === 0) {
      if (alertFunc) alertFunc("目前沒有任何資料！");
      return;
    }
    // find all nodes id
    const nodeIds = groupNetwork.nodes.map((n) => n.id);
    // transform nodesId to colsName(equal to rowsName)
    const colsName = ["", ...nodeIds];
    // create blank matrix array && matrix[0][0] === ''
    const matrix = [];
    matrix[0] = [""];
    colsName.forEach((val, idx) => {
      matrix[idx] = [];
      matrix[0][idx] = val;
      matrix[idx][0] = val;
    });
    // x: source , y: target
    // iterate groupNetwork.links
    groupNetwork.links.forEach((l) => {
      const rowNum = colsName.indexOf(l.source);
      const colNum = colsName.indexOf(l.target);
      matrix[rowNum][colNum] = l.count;
      matrix[colNum][rowNum] = l.count;
    });

    let preCsv = "";
    const separator = ",";
    // convert matrix to csv (tsv form)
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < colsName.length; i++) {
      // eslint-disable-next-line no-plusplus
      for (let j = 0; j < colsName.length; j++) {
        if ((i === j) === 0) {
          preCsv = preCsv.concat(separator);
        }
        if (matrix[i][j] === undefined) {
          preCsv = preCsv.concat(
            j === colsName.length - 1 ? `0` : `0${separator}`
          );
        } else {
          preCsv = preCsv.concat(
            j === colsName.length - 1
              ? `${matrix[i][j]}`
              : `${matrix[i][j]}${separator}`
          );
        }
      }
      preCsv = preCsv.concat("\n");
    }
    // create blob
    const csvToBlob = new Blob([preCsv], { type: "text/csv;charset=utf8" });
    const fileName = `relation-matrix-${new Date().getTime()}.csv`;
    // direct download
    downloadBlob(csvToBlob, fileName);
    if (onSuccess && typeof onSuccess === "function") {
      onSuccess();
    }
  } catch (err) {
    if (onError && typeof onError === "function") {
      onError(err);
    }
  }
};

const downloadGephi = (groupNetwork, alertFunc, onSuccess, onError) => {
  try {
    // check data
    if (groupNetwork && Object.keys(groupNetwork.nodes).length === 0) {
      if (alertFunc) alertFunc("目前沒有任何資料！");
      return;
    }
    const graph = new GraphAnalysis(groupNetwork.links, groupNetwork.nodes);
    const gexfContent = graph.getGexfFileContent();
    // create blob
    const txtToBlob = new Blob([gexfContent], { type: "application/xml" });
    const fileName = `gephi-${new Date().getTime()}.gexf`;
    // direct download
    downloadBlob(txtToBlob, fileName);
    if (onSuccess && typeof onSuccess === "function") {
      onSuccess();
    }
  } catch (err) {
    if (onError && typeof onError === "function") {
      onError(err);
    }
  }
};

export {
  exportImageHandler,
  handleExportMeetCount,
  relationMatrixExport,
  downloadGephi,
};
